/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Tag
 * @desc Tag filter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Tag } from 'labstep-web/models/tag.model';
import type React from 'react';
import FilterPostNewIndexTagForm from './Form';
import type { FilterPostNewIndexTagProps } from './types';

export const FilterPostNewIndexTag: React.FC<
  FilterPostNewIndexTagProps
> = ({ addPostFilter, ...rest }) => (
  <Modal
    header={`Filter by ${Tag.getHumanReadableEntityName(false, true)}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.tag.primary}
        text="Tags"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostNewIndexTagForm
        addPostFilter={addPostFilter}
        onDone={toggleModal}
      />
    )}
    {...rest}
  />
);
